import React from 'react'
import ContentEditable from 'react-contenteditable'

export default class EditableDiv extends React.Component {
  constructor() {
    super()
    this.contentEditable = React.createRef()
  }

  render = () => {
    return (
      <ContentEditable
        className='transparentTextInput'
        innerRef={this.contentEditable}
        html={this.props.html} // innerHTML of the editable div
        onChange={this.props.onChange} // handle innerHTML change
        onKeyPress={this.props.onKeyPress}
      />
    )
  }
}
